<template>
    <div class="flex flex-row items-center md:w-1/3 sm:w-1/2 mx-auto justify-center mt-3">
      <span class="font-semibold text-xs">{{ $t('powered-by') }}</span>
      <img v-if="isMiniBg" src="../../assets/images/001.png" class="w-3/12 ml-3" alt="Mini Bulgaria logo" />
      <img v-else src="../../assets/images/URBO-Redesigned-Logo.png" class="w-2/12 ml-3" alt="Urbo Studio logo" />
    </div>
</template>

<script>
export default {
  name: 'FooterUrboStudio',
  data() {
    return {
      isMiniBg: false,
    }
  },
  mounted() {
    if(this.$route.params && this.$route.params.hash && 
      (this.$route.params.hash == '5dfd2dfbd2f6501628e18d102b039b2b' || this.$route.params.hash == 'a56889cdcee8e94d768a2c8f5f774fad')) {
      this.isMiniBg = true;
    }
  }
}
</script>